import { useRef } from "react";
import {
    LuFile,
    LuFileSpreadsheet,
    LuFileText,
    LuUpload,
    LuX,
} from "react-icons/lu";
import { ACCEPT_TYPES } from "./utils";

const btnBase = {
    border: "1px solid var(--lighterGrey)",
    borderRadius: "0.35rem",
    padding: "0.45rem 0.9rem",
    fontSize: "0.875rem",
    cursor: "pointer",
    background: "var(--white)",
};

const btnSecondary = {
    ...btnBase,
    display: "inline-flex",
    alignItems: "center",
    gap: "0.4rem",
};

const btnPrimary = {
    ...btnBase,
    background: "var(--lightBlue)",
    borderColor: "var(--lightBlue)",
    color: "var(--white)",
};

const fileIconFor = (name = "") => {
    if (/\.(xlsx|xls|csv)$/i.test(name)) return LuFileSpreadsheet;
    if (/\.pdf$/i.test(name)) return LuFileText;
    return LuFile;
};

const VendorInvoiceUploadPanel = ({
    pendingFiles,
    addFiles,
    removeFile,
    primaryLabel,
    primaryLoadingLabel,
    primaryBusy = false,
    onPrimary,
    primaryDisabled,
    selectDisabled = false,
    hint = "PDF, XLSX, CSV",
}) => {
    const fileInputRef = useRef(null);

    return (
        <section style={{ display: "flex", flexDirection: "column", gap: "0.75rem", maxWidth: 640 }}>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "0.75rem" }}>
                <button
                    type="button"
                    style={{
                        ...btnSecondary,
                        opacity: selectDisabled ? 0.5 : 1,
                        cursor: selectDisabled ? "not-allowed" : "pointer",
                    }}
                    onClick={() => fileInputRef.current?.click()}
                    disabled={selectDisabled}
                >
                    <LuUpload size={16} />
                    Select files
                </button>
                <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    accept={ACCEPT_TYPES}
                    style={{ display: "none" }}
                    onChange={(e) => {
                        addFiles(e.target.files);
                        e.target.value = "";
                    }}
                />
                <button
                    type="button"
                    style={{
                        ...btnPrimary,
                        opacity: primaryDisabled ? 0.5 : 1,
                        cursor: primaryDisabled ? "not-allowed" : "pointer",
                    }}
                    disabled={primaryDisabled}
                    onClick={onPrimary}
                >
                    {primaryBusy && primaryLoadingLabel ? primaryLoadingLabel : primaryLabel}
                </button>
            </div>
            {hint && (
                <p style={{ fontSize: "0.85rem", color: "var(--darkGrey)", margin: 0 }}>
                    {hint}
                </p>
            )}

            {pendingFiles.length > 0 && (
                <ul style={{ listStyle: "none", display: "flex", flexDirection: "column", gap: "0.4rem", margin: 0, padding: 0 }}>
                    {pendingFiles.map((file) => {
                        const Icon = fileIconFor(file.name);
                        return (
                            <li
                                key={file.id}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "0.5rem",
                                    padding: "0.5rem 0.75rem",
                                    border: "1px solid var(--lighterGrey)",
                                    borderRadius: "0.35rem",
                                    fontSize: "0.9rem",
                                }}
                            >
                                <Icon />
                                <span style={{
                                    flex: 1,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                }}>
                                    {file.name}
                                </span>
                                {file.state === "uploading" && (
                                    <span style={{ fontSize: "0.8rem", color: "var(--darkGrey)" }}>
                                        {file.progress}%
                                    </span>
                                )}
                                {file.state === "ready" && (
                                    <span style={{ fontSize: "0.8rem", color: "var(--green)" }}>
                                        Ready
                                    </span>
                                )}
                                <button
                                    type="button"
                                    style={{
                                        background: "none",
                                        border: "none",
                                        cursor: selectDisabled ? "not-allowed" : "pointer",
                                        color: "var(--darkGrey)",
                                        display: "grid",
                                        placeItems: "center",
                                        padding: "0.2rem",
                                        opacity: selectDisabled ? 0.5 : 1,
                                    }}
                                    onClick={() => removeFile(file.id)}
                                    aria-label={`Remove ${file.name}`}
                                    disabled={selectDisabled}
                                >
                                    <LuX />
                                </button>
                            </li>
                        );
                    })}
                </ul>
            )}
        </section>
    );
};

export default VendorInvoiceUploadPanel;
